import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { $CurrentAvailableUserOrNull } from '@user/shared/atoms/current-user';

export const useUserDesc = (): string => {
  const { t } = useTranslation();
  const user = useAtomValue($CurrentAvailableUserOrNull);

  if (!user) {
    return '';
  }

  return t('user_helmet_description_1')
    .replace('%1$s', user.nickName || '')
    .replace('%2$s', user.description || '');
};
